/* @flow */
import { Record } from 'immutable';

export type EntityTypeObject = {
  guid: string,
  name: string,
  custom: boolean,
  default: boolean,
};

export const EntityType = Record({
  guid: null,
  name: null,
  custom: null,
  default: null,
});




// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/types.js